import { createTheme } from '@material-ui/core';
const theme = createTheme({
  palette: {
    primary: {
      main: "#e86642",
      light: "#ff9984",
    },
    secondary: {
      main: "#87d67e",
      light: "#CCF6C8",
    },
    black: "#2B2B2B",
    white: "#FAFAFA"
  },
});

export default theme;
